import { localStorageService } from "../../services/localstorage.service";
import * as Auth from "../../util/Auth";
import { Observable } from "@apollo/client";
import { onError } from "@apollo/client/link/error";

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
      let UNAUTHENTICATED
      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
          if (Number(extensions?.code) === 401) {
              UNAUTHENTICATED = true;
          }
      });
      if(UNAUTHENTICATED) {
          return new Observable((observer) => {
              const headers = operation.getContext().headers;
              resendRefreshToken().then((accessToken) => {
                  operation.setContext({
                      headers: {
                          ...headers,
                          authorization: `Bearer ${accessToken}`
                      }
                  });
                  const subscriber = {
                      next: observer.next.bind(observer),
                      error: observer.error.bind(observer),
                      complete: observer.complete.bind(observer),
                  };
                  return forward(operation).subscribe(subscriber);
              }).catch(error => {
                  console.error(error);
                  observer.error(error);
                  throw error;
              })
          })
      }
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});


export async function resendRefreshToken() {
  const refreshToken = localStorageService.getAuthRefreshToken();

  const data = JSON.stringify({
    "grant_type": "refresh_token",
    "refresh_token": refreshToken
  });

  const config = {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: data
  };
  const response = await fetch(`https://securetoken.googleapis.com/v1/token?key=${process.env.REACT_APP_FIREBASE_API_KEY}`, config);
  const jsonResponse = await response.json();
  const newAccessToken = jsonResponse.access_token;

  Auth.setToken(newAccessToken);
  return newAccessToken;
}

export default errorLink;
